<template>
  <v-dialog
    v-model="dialog_re"
    max-width="1200px"
    scrollable
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDriverCreateDialog"
  >
    <!-- <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot />
      </div>
    </template> -->
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        {{ $i18n.t("Add Driver") }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeDriverCreateDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form id="form">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ $i18n.t("Add New Vehicle") }}
            </div>
          </template>
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="vehicleDriver.marketDriver"
                  :label="$i18n.t('Market Driver')"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="!vehicleDriver.marketDriver">
                <z-vendor-select
                  v-model="vehicleDriver.supplier_id"
                  :title="$i18n.t('Supplier') + '*'"
                  withSelf
                />
              </v-col>

              <!-- <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <v-text-field
                  v-model="vehicleDriver.supplierName"
                  :label="$i18n.t('Supplier Name') + '*'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <v-text-field
                  v-model="vehicleDriver.supplierTaxId"
                  :label="$i18n.t('Tax Id') + '*'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <z-country-select
                  madatoryMark="true"
                  v-model="vehicleDriver.supplierAddress.country"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <z-city-select
                  madatoryMark="true"
                  v-model="vehicleDriver.supplierAddress.city"
                  :country="vehicleDriver.supplierAddress.country"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <v-text-field
                  v-model="vehicleDriver.supplierTaxId"
                  :label="$i18n.t('Address Line')"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <v-text-field
                  v-model="vehicleDriver.supplierContact.name"
                  :label="$i18n.t('Contact Person Name') + '*'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <v-row>
                  <v-col cols="12" md="4">
                    <z-country-select
                      preIcon="mdi-earth"
                      v-model="vehicleDriver.supplierContact.countryCode"
                      :label="$i18n.t('Code') + '*'"
                      isd
                      hideName
                      hideFlag
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :label="$i18n.t('Phone') + '*'"
                      name="login"
                      prepend-icon="person"
                      type="text"
                      v-model="vehicleDriver.supplierContact.phone"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleDriver.forAdhoc">
                <v-text-field
                  v-model="vehicleDriver.supplierContact.email"
                  :label="$i18n.t('Contact Person Email') + '*'"
                />
              </v-col> -->

              <!-- <v-col cols="12" md="3">
                <toggle-button
                  v-model="vehicleDriver.forAdhoc"
                  :labels="{
                    checked: $i18n.t('Adhoc'),
                    unchecked: $i18n.t('Saved'),
                  }"
                  lg
                  :height="30"
                  :width="100"
                  :font-size="20"
                />
              </v-col> -->
            </v-row>
            <v-row>
              {{
                forDriver ? $i18n.t("Driver Detail") : $i18n.t("Vehicle Detail")
              }}
            </v-row>
            <!-- <v-row v-if="!forDriver">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="vehicleDriver.regNo"
                  :label="$i18n.t('Vehicle Reg. No') + '*'"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2">
                <z-vehicle-type-select
                  :label="$i18n.t('Vehicle Type') + '*'"
                  v-model="vehicleDriver.vehicleType"
                />
              </v-col>
              <v-col cols="12" md="2">
                <z-country-select
                  madatoryMark="true"
                  v-model="vehicleDriver.country"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2">
                <v-autocomplete
                  :label="$i18n.t('Fuel Type')"
                  :items="CommonUtil.getFuelTypeList()"
                  v-model="vehicleDriver.fuelType"
                  item-text="name"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
            </v-row> -->
            <v-row v-if="forDriver">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="vehicleDriver.name"
                  :label="$i18n.t('Name') + '*'"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-row>
                  <v-col cols="12" md="4">
                    <z-country-select
                      preIcon="mdi-earth"
                      v-model="vehicleDriver.countryCode"
                      :label="$i18n.t('Code') + '*'"
                      isd
                      hideName
                      hideFlag
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :label="$i18n.t('Phone') + '*'"
                      prepend-icon="phone"
                      type="number"
                      v-model="vehicleDriver.phone"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="vehicleDriver.dlNo"
                  :label="$i18n.t('Drivers License') + '*'"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="vehicleDriver.aadhar"
                  :label="$i18n.t('Aadhar Number')"
                />
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col cols="12" sm="2" md="2" lg="2">
                <v-checkbox
                  v-model="vehicleDriver.saveToDB"
                  :label="$i18n.t('Save to Master')"
                />
              </v-col> -->
              <v-col cols="12" sm="10" md="10" lg="10" class="text-right">
                <v-btn
                  color="success"
                  class="mr-0"
                  @click="save()"
                  :loading="loading"
                >
                  <h3>
                    {{
                      vehicleDriver.marketDriver
                        ? $i18n.t("Assign Driver")
                        : $i18n.t("Save Driver")
                    }}
                  </h3>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component, Watch } from "vue-property-decorator";
import { CommonUtil } from "@/js/commonUtil";

@Component({
  props: {
    label: {
      default: "Create Adhoc Vehicle",
    },
    trip_id: {
      default: null,
    },
    owner_id: {
      default: null,
    },
    forDriver: {
      default: false,
    },
    driverCreateDialog: {
      default: null,
    },
  },
})
export default class VehicleCreateAdhoc extends Vue {
  vehicleDriverPOSO = {
    forAdhoc: null,
    countryCode: 91,
    // adhocSupplier: false,
    saveToDB: true,
    supplierAddress: {},
    supplierContact: {},
  };
  vehicleDriver = this.vehicleDriverPOSO;
  CommonUtil = CommonUtil;
  dialog_re = false;

  get loading() {
    return common.loading;
  }

  setAdhocVehicle(data) {
    this.$emit("setAdhocVehicle", data);
    // this.dialog = false;
  }

  setAdhocDriver(data) {
    this.$emit("setAdhocDriver", data);
    this.closeDriverCreateDialog();
  }

  closeDriverCreateDialog() {
    this.$emit("closeDriverCreateDialog");
  }

  @Watch("driverCreateDialog")
  onDriverCreateDialogChange(val) {
    this.dialog_re = val;
    if (!val) this.closeDriverCreateDialog();
  }

  @Watch("owner_id")
  onDriverOwnerChange(val) {
    this.vehicleDriver.supplier_id = val;
  }

  async save() {
    try {
      if (this.vehicleDriver.marketDriver) {
        if (!this.vehicleDriver.name) {
          common.setError("Please provide name.");
          return false;
        }
        if (!this.vehicleDriver.phone) {
          common.setError("Please provide phone.");
          return false;
        }
        this.setAdhocDriver(this.vehicleDriver);
      } else {
        common.setLoading(true);
        const response = await doPost(
          `/api/trip/${this.trip_id}/makeVehicleDriver?forDriver=${this.forDriver}`,
          this.vehicleDriver
        );
        common.setLoading(false);
        common.showMessage(`Vehicle Added Successfully`);
        if (!this.forDriver) this.setAdhocVehicle(response);
        else this.setAdhocDriver(response);
        this.vehicleDriver = this.vehicleDriverPOSO;
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  //   async mounted() {}

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
